import { useTranslation } from 'react-i18next';

const benefits = [
  {
    icon: 'ri-percent-line',
    colorBg: 'bg-[#F8F3FB]',
    colorIcon: 'text-[#4F2D63]',
    titleKey: 'benefit_1_title',
    descKey: 'benefit_1_desc',
  },
  {
    icon: 'ri-timer-flash-line',
    colorBg: 'bg-amber-50',
    colorIcon: 'text-amber-600',
    titleKey: 'benefit_2_title',
    descKey: 'benefit_2_desc',
  },
  {
    icon: 'ri-exchange-dollar-line',
    colorBg: 'bg-[#F0FDF9]',
    colorIcon: 'text-[#0F766E]',
    titleKey: 'benefit_3_title',
    descKey: 'benefit_3_desc',
  },
];

export default function BenefitsStrip() {
  const { t } = useTranslation();

  return (
    <section className="py-12 px-6 lg:px-8 bg-white border-b border-[#E9D9F2]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {benefits.map(({ icon, colorBg, colorIcon, titleKey, descKey }) => (
            <div
              key={titleKey}
              className="flex items-start gap-4 bg-[#FCFAFD] rounded-xl p-5 border border-[#E9D9F2]"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${colorBg} flex-shrink-0`}>
                <i className={`${icon} ${colorIcon} text-lg`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-1">
                  {t(titleKey)}
                </h3>
                <p className="text-xs text-gray-500 leading-relaxed">
                  {t(descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
